const mountDataFromTo = {
  id: 'id',
  code: 'codigoLote',
  precificationCode: 'codigoPrecificacao',
  plate: 'placa',
  typeSurvey: 'tipoVistoria',
  typeEvaluation: 'tipoAvaliacao',
  situation: 'situacao',
  model: 'modelo',
  yearModel: 'anoModelo',
  typeCount: 'tipoContador',
  actualCount: 'contadorAtual',
  hasImplement: 'possuiImplemento',
  directory: 'proprietarioDiretoria',
  cr: 'crContrato',
  dateConclusionPrecification: 'dataConclusaoPrecificacao',
  vehicleStatus: 'statusVeiculo',
  useType: 'tipoUso',
  active: 'localAtivo',
  precificationPercent: 'percentualPrecificacao',
  precificationValue: 'valorPrecificacao',
  minValue: 'valorMinimo',
  mediumValue: 'valorMedio',
  maxValue: 'valorMaximo',
  residualValue: 'valorResidualTotal',
  lastDate: 'dataAlteracao',
  lastUser: 'usuarioAlteracao',
  idSurvey: 'vistoriaId',
  hiddenModelId: 'modeloId',
  observation: 'observacao'
};

const mountDataFromInspection = {
  id: 'id',
  pricedSurvey: 'vistoriaPrecificacada',
  typeVehicle: 'tipoVeiculo',
  plate: 'placa',
  typeSurvey: 'tipoVistoria',
  typeEvaluation: 'tipoAvaliacao',
  situation: 'situacao',
  model: 'modelo',
  yearModel: 'anoModelo',
  typeCount: 'tipoContador',
  actualCount: 'contadorAtual',
  vehicleStatus: 'statusVeiculo',
  useType: 'tipoUso',
  category: 'categoria',
  color: 'cor',
  count: 'contador',
  inspectionCode: 'tipoAvaliacao',
  dateConclusion: 'dataConclusaoVistoria'
};

export const convertPrecificationMountData = (propertyName: any) => 
  mountDataFromTo[propertyName as keyof typeof mountDataFromTo] ?? propertyName

export const convertPrecificationFromInspectionMountData = (propertyName: any) => 
  mountDataFromInspection[propertyName as keyof typeof mountDataFromInspection] ?? propertyName
